//@ts-nocheck
import { Transaction } from "@/types/transaction-type";
import { create } from "zustand";

type ModalStore = {
    isOpen: boolean;
    transaction: Transaction | undefined;
    toggleIsOpen: () => void;
    setTransaction: (transaction: Transaction) => void;
}


export const useModalStore = create<ModalStore>((set) => ({
    isOpen: false,
    transaction: undefined,
    toggleIsOpen: () => {
        set((state) => {
            if (state.isOpen) {
                return { isOpen: false }
            } else {
                return { isOpen: true }
            }
        }
        )
    },
    setTransaction: (transaction) => {
        set((state) => {
            if (transaction) {
                return { transaction }
            }
        }
        )
    }
}))
